import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ChartType, ColumnChartName } from '@ddt-web/chart';
import { ColorsConfig, EsgConstants } from '@ddt-web/config';
import { InjectConfig, PcConfigKey } from '@ddt-web/config-layer';
import { ChartConfig } from '@ddt-web/data-layer-components';
import { ComponentData, TabData, TabUtil } from '@ddt-web/data-service';

import { extractAsOfDateFromMultiplePortfolios } from '../utils/esg-date.utils';

@Component({
	selector: 'esg-rating-distribution',
	templateUrl: './esg-rating-distribution.component.html',
	styleUrls: ['./esg-rating-distribution.component.scss']
})
export class EsgRatingDistributionComponent implements OnInit, OnChanges {
	@Input() public data: ComponentData;
	@Input() public showNoRatingHoldingsComponent: boolean = false;
	@Input() public showHeader: boolean = true;
	@InjectConfig(PcConfigKey.SHOW_AS_OF_DATE_DYNAMIC) public readonly showAsOfDateDynamic: boolean = EsgConstants.SHOW_AS_OF_DATE_DYNAMIC_DEFAULT;

	public asOfDate: string;
	public portfolioCount: number;
	public tableData: TabData;
	public chartData: TabData[];

	public chartConfig: [ChartConfig];
	public readonly PORTFOLIO_COLORS = ColorsConfig.PORTFOLIO_COLORS;

	public ngOnInit(): void {
		this.chartConfig = [new ChartConfig(ChartType.Column, ColumnChartName.GroupedColumnChart, {
			yAxis: {
				tickAmount: 5,
				labels: {
					format: '{value:1f}',
					formatter: null
				}
			}
		})];
	}

	public ngOnChanges(): void {
		if (this.data.success) {
			this.asOfDate = extractAsOfDateFromMultiplePortfolios(this.data.getTabById('esg.asOfDate'));
			const tableData: TabData = this.data.getTabById('esg.rating.distribution.table');
			this.tableData = TabUtil.isTabValid(tableData) ? tableData : undefined;
			const chartData: TabData = this.data.getTabById('esg.rating.distribution.chart');
			this.chartData = TabUtil.isTabValid(chartData) ? [chartData] : undefined;
			this.portfolioCount = this.data.portfolioData?.length;
		}
	}
}
